import { useMutation } from "@apollo/client";
import type {
  UpdateOrganizationBySlugInput,
  UpdateOrganizationPayload,
} from "@casey/db-types";
import {
  UPDATE_ORGANIZATION_ONBOARDING_STATUS,
  GET_ORGANIZATION_ONBOARDING_STATUS,
} from "../gql";

interface UpdateTeamOnboardingStatusVariables {
  input: UpdateOrganizationBySlugInput;
}

interface UpdateTeamOnboardingStatusResponse {
  updateOrganizationBySlug: UpdateOrganizationPayload;
}

export function useUpdateOrganizationOnboardingStatus() {
  const [updateTeamOnboardingStatusMutation, { data, loading, error }] =
    useMutation<
      UpdateTeamOnboardingStatusResponse,
      UpdateTeamOnboardingStatusVariables
    >(UPDATE_ORGANIZATION_ONBOARDING_STATUS, {
      errorPolicy: "all",
      onError: (error) => {
        console.error("Error updating organization onboarding status:", error);
      },
    });

  const updateOnboardingStatus = async (
    organizationSlug: string,
    onboardingStatus: any,
    step: number,
  ) => {
    try {
      const result = await updateTeamOnboardingStatusMutation({
        variables: {
          input: {
            slug: organizationSlug,
            patch: {
              onboardingStatus: JSON.stringify({
                ...onboardingStatus,
                currentStep: step,
                lastUpdated: new Date().toISOString(),
              }),
            },
          },
        },
        // Don't automatically refetch to avoid loops
      });

      const updatedTeam = result.data?.updateOrganizationBySlug?.organization;
      if (updatedTeam) {
        console.log(`Onboarding data saved for step ${step}`);
      }

      return updatedTeam;
    } catch (err) {
      console.error("Error updating onboarding status:", err);
      // Don't show error toast to user since this is background operation
      throw err;
    }
  };

  return {
    updateOnboardingStatus,
    data: data?.updateOrganizationBySlug?.organization,
    loading,
    error,
  };
}
